import { render, staticRenderFns } from "./dialogEdit.vue?vue&type=template&id=ece25ec2&"
import script from "./dialogEdit.vue?vue&type=script&lang=js&"
export * from "./dialogEdit.vue?vue&type=script&lang=js&"
import style0 from "./dialogEdit.vue?vue&type=style&index=0&id=ece25ec2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports